import React, { useEffect } from "react";
import { useSetting } from "store/settings";
import { handleSuccessMessages } from "store/auth";
import { Field, Form, Formik } from "formik";
import { Loading, TextField, TextArea } from "components/form";
import { required, validationWrapper } from "lib/formValidations";
const NotificationTexts = (props) => {
  const {
    dispatch,
    getSetting,
    submitSetting,
    verification_texts,
    loading,
  } = useSetting();
  const key = "verification_texts";

  useEffect(() => {
    dispatch(getSetting(key));
  }, []);

  if (loading) {
    return (
      <div className="box p-5 flex justify-center">
        <Loading />
      </div>
    );
  }

  return (
    <>
      <Formik
        initialValues={verification_texts || {}}
        onSubmit={async (values, { setSubmitting }) => {
          await dispatch(
            submitSetting({ value: values, key }, () =>
              handleSuccessMessages("ویرایش اطلاعات انجام شد")
            )
          );
          setSubmitting(false);
        }}
        enableReinitialize
      >
        {({ isSubmitting, dirty }) => (
          <Form>
            <div className="box rounded p-3">
              <h3>متن اعلان ها</h3>
              <hr className="my-2" />
              <div className="">
                <div className="intro-x grid grid-cols-2 gap-4">
                  {/* verification */}
                  <div>
                    <Field
                      placeholder="عنوان کد تایید"
                      label="عنوان کد تایید :"
                      name="verification_title"
                      component={TextField}
                    />
                    <Field
                      placeholder="متن کد تایید"
                      label="متن کد تایید :"
                      name="verification_body"
                      component={TextArea}
                    />
                  </div>
                  <div>
                    <Field
                      placeholder="عنوان کد تایید (انگلیسی)"
                      label="عنوان کد تایید(انگلیسی) :"
                      name="en_verification_title"
                      component={TextField}
                    />
                    <Field
                      placeholder="متن کد تایید (انگلیسی)"
                      label="متن کد تایید (انگلیسی) :"
                      name="en_verification_body"
                      component={TextArea}
                    />
                  </div>
                  {/* charge wallet */}
                  <div>
                    <Field
                      placeholder="عنوان شارژ کیف پول"
                      label="عنوان شارژ کیف پول :"
                      name="charge_wallet_title"
                      component={TextField}
                    />
                    <Field
                      placeholder="متن شارژ کیف پول"
                      label="متن شارژ کیف پول :"
                      name="charge_wallet_body"
                      component={TextArea}
                    />
                  </div>
                  <div>
                    <Field
                      placeholder="عنوان شارژ کیف پول (انگلیسی)"
                      label="عنوان شارژ کیف پول(انگلیسی) :"
                      name="en_charge_wallet_title"
                      component={TextField}
                    />
                    <Field
                      placeholder="متن شارژ کیف پول (انگلیسی)"
                      label="متن شارژ کیف پول (انگلیسی) :"
                      name="en_charge_wallet_body"
                      component={TextArea}
                    />
                  </div>

                  {/* خرید فیلم */}
                  <div>
                    <Field
                      placeholder="عنوان خرید فیلم"
                      label="عنوان خرید فیلم :"
                      name="buy_movie_title"
                      component={TextField}
                    />
                    <Field
                      placeholder="متن خرید فیلم"
                      label="متن خرید فیلم :"
                      name="buy_movie_body"
                      component={TextArea}
                    />
                  </div>
                  <div>
                    <Field
                      placeholder="عنوان خرید فیلم (انگلیسی)"
                      label="عنوان خرید فیلم(انگلیسی) :"
                      name="en_buy_movie_title"
                      component={TextField}
                    />
                    <Field
                      placeholder="متن خرید فیلم (انگلیسی)"
                      label="متن خرید فیلم (انگلیسی) :"
                      name="en_buy_movie_body"
                      component={TextArea}
                    />
                  </div>

                  {/* خرید اشتراک */}
                  <div>
                    <Field
                      placeholder="عنوان خرید اشتراک"
                      label="عنوان خرید اشتراک :"
                      name="buy_subscription_title"
                      component={TextField}
                    />
                    <Field
                      placeholder="متن خرید اشتراک"
                      label="متن خرید اشتراک :"
                      name="buy_subscription_body"
                      component={TextArea}
                    />
                  </div>
                  <div>
                    <Field
                      placeholder="عنوان خرید اشتراک (انگلیسی)"
                      label="عنوان خرید اشتراک(انگلیسی) :"
                      name="en_buy_subscription_title"
                      component={TextField}
                    />
                    <Field
                      placeholder="متن خرید اشتراک (انگلیسی)"
                      label="متن خرید اشتراک (انگلیسی) :"
                      name="en_buy_subscription_body"
                      component={TextArea}
                    />
                  </div>

                  {/* خرید اشتراک با تمدید خودکار */}
                  <div>
                    <Field
                      placeholder="عنوان خرید اشتراک با تمدید"
                      label="عنوان خرید اشتراک با تمدید:"
                      name="buy_dd_subscription_title"
                      component={TextField}
                    />
                    <Field
                      placeholder="متن خرید اشتراک با تمدید"
                      label="متن خرید اشتراک با تمدید:"
                      name="buy_dd_subscription_body"
                      component={TextArea}
                    />
                  </div>
                  <div>
                    <Field
                      placeholder="عنوان خرید اشتراک با تمدید(انگلیسی)"
                      label="عنوان خرید اشتراک با تمدید(انگلیسی) :"
                      name="en_buy_dd_subscription_title"
                      component={TextField}
                    />
                    <Field
                      placeholder="متن خرید اشتراک با تمدید(انگلیسی)"
                      label="متن خرید اشتراک با تمدید(انگلیسی) :"
                      name="en_buy_dd_subscription_body"
                      component={TextArea}
                    />
                  </div>

                  {/* خرید اشتراک با تمدید خودکار */}
                  <div>
                    <Field
                      placeholder="عنوان خرید اشتراک با تمدید(ناموفق)"
                      label="عنوان خرید اشتراک با تمدید(ناموفق):"
                      name="buy_failed_dd_subscription_title"
                      component={TextField}
                    />
                    <Field
                      placeholder="متن خرید اشتراک با تمدید(ناموفق)"
                      label="متن خرید اشتراک با تمدید(ناموفق):"
                      name="buy_failed_dd_subscription_body"
                      component={TextArea}
                    />
                  </div>
                  <div>
                    <Field
                      placeholder="عنوان خرید اشتراک با تمدید(ناموفق)(انگلیسی)"
                      label="عنوان خرید اشتراک با تمدید(ناموفق)(انگلیسی) :"
                      name="en_buy_failed_dd_subscription_title"
                      component={TextField}
                    />
                    <Field
                      placeholder="متن خرید اشتراک با تمدید (ناموفق)(انگلیسی)"
                      label="متن خرید اشتراک با تمدید (ناموفق)(انگلیسی) :"
                      name="en_buy_failed_dd_subscription_body"
                      component={TextArea}
                    />
                  </div>

                  {/* خرید بلیت */}
                  <div>
                    <Field
                      placeholder="عنوان خرید بلیت"
                      label="عنوان خرید بلیت :"
                      name="buy_ticket_title"
                      component={TextField}
                    />
                    <Field
                      placeholder="متن خرید بلیت"
                      label="متن خرید بلیت :"
                      name="buy_ticket_body"
                      component={TextArea}
                    />
                  </div>
                  <div>
                    <Field
                      placeholder="عنوان خرید بلیت (انگلیسی)"
                      label="عنوان خرید بلیت(انگلیسی) :"
                      name="en_buy_ticket_title"
                      component={TextField}
                    />
                    <Field
                      placeholder="متن خرید بلیت (انگلیسی)"
                      label="متن خرید بلیت (انگلیسی) :"
                      name="en_buy_ticket_body"
                      component={TextArea}
                    />
                  </div>

                  <button
                    className="mt-4 btn btn-primary w-20"
                    type="submit"
                    disabled={!!(isSubmitting || !dirty)}
                  >
                    {isSubmitting ? <Loading /> : "ذخیره"}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default NotificationTexts;
